import React from 'react';
import {
    defineBlock,
    useEditor,
    useInspectorControl,
    smartProps,
    useToolbar,
    BlockWrapper,
} from '@smartfire/js-block-engine';
import Inspector from './Inspector';
import Toolbar from './Toolbar';
import * as BlockEditor from '@wordpress/block-editor';
import { ReactComponent as Arrow } from '../assets/arrow-right.svg';
import style from './block.module.scss';
import clsx from 'clsx';

const useBlockProps =
    BlockEditor.useBlockProps ??
    ((a) => {
        return a;
    });

const Button = ({ text, link, aspect, alignment, blank, color, showInspector = true, showToolBar = true }) => {
    useInspectorControl(showInspector && Inspector);
    useToolbar(showToolBar && Toolbar);
    const { isEditing } = useEditor();

    const blockClasses = clsx({
        [style.block]: true,
        [style.middle]: alignment === 'middle',
        [style.right]: alignment === 'right',
        [style.contained]: aspect === 'contained',
        [style.outlined]: aspect === 'outlined',
        [style.ghost]: aspect === 'ghost',
        [style.color]: aspect === 'ghost' && color,
    });

    const Wrapper = isEditing ? 'div' : 'a';

    const blockContext2 = useBlockProps({
        className: blockClasses,
    });

    return (
        <BlockWrapper.Without>
            <div {...blockContext2}>
                <Wrapper
                    className={style.link}
                    href={isEditing ? undefined : link}
                    target={blank ? '_blank' : undefined}
                >
                    {aspect === 'ghost' && <Arrow />}
                    <span>{text}</span>
                </Wrapper>
            </div>
        </BlockWrapper.Without>
    );
};

export default defineBlock({
    Block: Button,
    smartProps: {
        text: smartProps.string.withDefault('Text du bouton'),
        linkType: smartProps.string.withDefault('internal'),
        link: smartProps.string.withDefault(''),
        aspect: smartProps.string.withDefault('contained'),
        blank: smartProps.bool.withDefault(false),
        alignment: smartProps.string.withDefault('left'),
        color: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Bouton',
        icon: 'button',
    },
});
